export default {
  ReasonTitle: 'Add reason for status change',
  ReasonPrompt: 'Why was this client moved to #{status}?',
  Reason: 'Reason',
  ReasonPlaceholder: 'Enter the reason for this status change',
  Pill: {
    LostReason: 'Lost: #{value}',
    InactiveReason: 'Inactive: #{value}',
  },
  Errors: {
    CLT_007: 'Choose a reason for this stage.',
    Default: 'Could not change the stage. Try again.',
  },
};
